import { useEffect, useState } from "react";
import PageHead from "../../../../Components/PageHead/PageHead";
import SvgOptions from "../../../../Components/Svg/SvgOptions";
import css from "./Risk.module.css";
import empty_state from "../../../../Assets/Images/no_template.svg";
import { useNavigate } from "react-router-dom";
import { Get } from "../../../../Services/Server";
import Url from "../../../../Services/Url";
import Template from "./Template";
import { toast } from "react-toastify";

const EmptyState = () => {
	return (
		<div className={css.EmptyState}>
			<img src={empty_state} alt="empty" />
			<h4>No Templates Found</h4>
			<p>
				There are no risk assessment templates available for use. <br />
				Create a new template to continue with your task.
			</p>
		</div>
	);
};

const RiskTemplateList = ({ navoption }) => {
	const navigate = useNavigate();

	const [templates, setTemplates] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const handleAddQuestion = () => navigate("CreateQuestion");
	const handleAddTemplate = () => navigate("CreateTemplate");

	// Fetch templates from backend
	useEffect(() => {
		Get(Url.riskTemplate.getTemplates)
			.then((data) => {
				setTemplates(data);
				setLoading(false);
			})
			.catch(() => {
				toast("Unable to fetch templates");
				setLoading(false);
			});
	}, []);

	return (
		<div className={css.MilestoneTemplates}>
			<PageHead
				backControl={true}
				buttons={[
					{
						text: "Create Templates",
						onClick: handleAddTemplate,
						icon: SvgOptions.Add,
					},
					{
						text: "Risk Questions",
						onClick: handleAddQuestion,
						icon: SvgOptions.Add,
						className: "Inverse",
					},
				]}
				navoption={navoption}
				hideIcon={true}
				title="Risk Templates"
			/>
			{loading && <p className={css.Loading}>Loading templates...</p>}

			{!loading && templates.length === 0 && <EmptyState />}

			<div className={css.Templates}>
				{!loading &&
					templates.length > 0 &&
					templates.map((t, index) => (
						<Template key={index}>
							{{
								name: t.name,
								type: t.taskType,
								use_case: t.usecase,
								id: t.id,
								full: t,
							}}
						</Template>
					))}
			</div>
		</div>
	);
};

export default RiskTemplateList;
